export default __webpack_public_path__ + "static/best2026-99a401349517e9b823c6b020e2d1dbf1.jpeg";